module.exports = __webpack_public_path__ + "img/ExitusUX_head.e0c670a5.png";